
/**
 * 加载组件
 * @param view
 * @returns {function(): (Promise<*>|*)}
 */
import router from '../_router'
import { listApp } from '../api/manage'
export const loadView = (view) => {
  let str = ''
  if (view.includes('/app/')) {
    str = '/apps/' + view.split('/app/')[1]
  } else {
    str = view
  }
  return () => import(`@/pages${str}`)
  // return () => import(view)
}
export const filterAsyncRouter = (routers) => {
  return routers.filter(router => {
    if (router.component) {
      // if (router.nodeData.component === 'Layout') { // Layout组件特殊处理
      //     console.log(router.nodeData.component,'-------------')
      //   // router.component = Layout
      //   router.component = () => import('@/layout')
      //   // router.component = loadAll('layout')
      // } else {
      // console.log(router.nodeData.component)
      const component = router.path
      router.component = loadView(component)
      // }
    }

    router.name = router.name
    router.meta = { title: router.meta.title, icon: router.meta.icon }
    // const meta = router.meta
    // if (meta !== undefined && meta !== null && meta !== '') {
    //   const json = JSON.parse(meta)
    //   if (json.affix) {
    //     router.meta.affix = json.affix
    //   }
    // }

    router.path = router.path
    // router.redirect = router.redirect
    //
    if (router.children && router.children.length > 0) {
      router.children = filterAsyncRouter(router.children)
    } else {
      delete router.children
    }
    return true
  })
}


export const newfilterAsyncRouter = (routers) => {
  let arr = []
  routers.forEach(ele => {
    if (ele.children && ele.children.length > 0) {
      ele.children.forEach(li => {
        arr.push({
          name: li.name,
          path: li.path,
          component: loadView(li.path),
          meta: {
            title: li.meta.title
          }
        })
      })
    }
  });
  return arr
}


export const getNewRoute = (projectId) => {
  listApp({ projectId }).then(res => {
    if (res.data.code === 200) {
      let routerArr = []
      res.data.data.forEach(item => {
        if (item.menuId == '1800339298076577794') {
          routerArr.push(...item.children)
        }
      })
      const routesArr = newfilterAsyncRouter(routerArr)
      routesArr.forEach(arr => {
        router.addRoute(arr)
      });
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/appUtil.js